import axios from 'axios';

/**
 * Create a user and login
 *
 * @param {*} userDetails
 */

const createUser = async (
  apiClient,
  userDetails,
) => {
  const { fullName, password, email } = userDetails;
  const [firstName, ...rest] = fullName.split(' ');
  const lastName = rest.join(' ');

  //1. create new user
  const user = await apiClient.user.create({
    firstName,
    lastName,
    email,
    password
  });

  //2. log user in
  await axios.post('/login', {
    email,
    password,
  });

  return user;
};

export default createUser;
